import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useOpenEditServiceOrdersModal } from '../../../utils/routes/modals/modalsActions'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text, { Title } from '../../../packages/kiti/components/presentation/Text'
import { useParent } from './_load/ParentLoader'

const ModalHeader = () => {
  const parent = useParent()
  const { t } = useTranslation('editServiceOrder')

  const { id, cloneFromId, initialState } = useModalData() || {}
  const isEditing = id > 0

  let context = isEditing && 'edit'
  if (!!cloneFromId) context = 'reopening'
  const title = t('title', { context })
  const openBulkModal = useOpenEditServiceOrdersModal(
    parent ? { id: parent.id, yearlyId: parent.yearlyId, checklistName: parent.checklist.name } : null
  )

  // TODO: Think of a way to make formReplyId and parentId check more dynamic
  const canGoToBulk = !isEditing && !cloneFromId && !initialState?.formReplyId

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={1}>
          <Title size="h5" bold>
            {title}
          </Title>
        </Col>
        {canGoToBulk && (
          <Col>
            <Text color="primary" size="xsmall" bold onClick={openBulkModal}>
              {t('bulkRegistration')}
            </Text>
          </Col>
        )}
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
